export const storeLocator = {
    partnerStores: "storeLocator.partnerStores",
    eccoStore: "storeLocator.eccoStore",
    partnerStore: "storeLocator.partnerStore",
    hoursNotAvailable: "storeLocator.hoursNotAvailable",
    hoursNotAvailableExtended: "storeLocator.hoursNotAvailableExtended",
    ariaLabels: {
        loadingToggleAria: "storeLocator.loadingToggleAria",
    },
};
